import axios from "axios";
import { EMPLOYEE_DASHBOARD_API_URL } from "../../api_helper";

axios.interceptors.request.use((req) => {
    if (localStorage.getItem("access")) {
        req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("access")).access_token}`;
    }
    return req;
});

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

// Send otp to Initiate Complete KYC Reg Form 
export const send_complete_kyc_reg_otp_api = (formData) =>
  axios.post(EMPLOYEE_DASHBOARD_API_URL + "otp/send_complete_kyc_reg_otp", formData, { withCredentials: false });

// Send otp to Initiate Complete KYC Reg Form verify_complete_kyc_reg_otp
export const verify_complete_kyc_reg_otp_api = (formData) =>
  axios.post(EMPLOYEE_DASHBOARD_API_URL + "otp/verify_complete_kyc_reg_otp", formData, { withCredentials: false });
